import view from "../../views/matchdetails";
import KTAPI from "../api/index.api";
import KTDrawer from "../components/drawer";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";
import { KTLang } from "../lang/lang";
import { errorMsg } from "./offscreen.controller";


import { _user, _handler } from "../classes/index.classes";


let states = [
    "DEAD",
    "WARM",
    "START",
    "FH",
    "HT",
    "SH",
    "OT",
    "END"    
];

const ROUND_NONE = 0;
const ROUND_TARGET_BOMB = 1;
const ROUND_VIP_ESCAPED = 2;
const ROUND_VIP_ASSASSINATED = 3;
const ROUND_TERRORISTS_ESCAPED = 4;
const ROUND_CTS_PREVENT_ESCAPE = 5;
const ROUND_ESCAPING_TERRORISTS_NEUTRALIZED = 6;
const ROUND_BOMB_DEFUSED = 7;
const ROUND_CTS_WIN = 8;
const ROUND_TERRORISTS_WIN = 9;
const ROUND_END_DRAW = 10;
const ROUND_ALL_HOSTAGES_RESCUED = 11;
const ROUND_TARGET_SAVED = 12;
const ROUND_HOSTAGE_NOT_RESCUED = 13;
const ROUND_TERRORISTS_NOT_ESCAPED = 14;
const ROUND_VIP_NOT_ESCAPED = 15;
const ROUND_GAME_COMMENCE = 16;
const ROUND_GAME_RESTART = 17;
const ROUND_GAME_OVER = 18;

let scoreBoardA = null;
let scoreBoardB = null;
let all = new Array(49).fill().map((_, i) => i);
let columns = {
    "main": [0,1,2,3,4,5,6,9,10,11,13,14,22,25,26,27,29,30,31,32,33,34,35,36],
    "aim": [0,1,2,38,39,40,41,42,43,44,45,46,47,48],
    "special": [0,1,2,7,8,12,13,14,15,16,17,18,19,20,21],
    "all": all
};


let match = {
    render: () => {        
        return view;
    },
    after_render: async (data) => {    
                     
        //console.log(data);


        
        if(!_user.authed)
        {  

        }
        else
        {            
            

        }
        
        renderMatchDetails(data);

        KTScroll.init();

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content',
};


$(document).ready(function(){    
    
    $(document).on("show.bs.tab", "span.scoreboard-pill[data-bs-toggle=tab]", function (e) {
        
        let table = $(this).attr("team") == "A" ? scoreBoardA : scoreBoardB;
        let numCols = table.columns().nodes().length;        
        console.log("numCols",numCols);
        table.columns(all).visible(false);
        table.columns(columns[$(this).attr("tab")]).visible(true);

        $($.fn.dataTable.tables(true)).DataTable().columns.adjust().scroller.measure();
        $(`#team${$(this).attr("team")}-scoreboard`).find("[data-toggle=tooltip]").tooltip();
    });

    $(document).on("click", ".hover-round-kill", function (e) {
        $(`#round-${$(this).attr("round")}-details`).collapse('show');
    });

    $(document).on("mouseover", ".hover-round-kill", function (e) {
        $(`.feed-round-kill[round=${$(this).attr("round")}][order=${$(this).attr("order")}]`).addClass("bg-light-primary").addClass("justify-content-center").removeClass("animate__fadeInDown").addClass("animate__pulse");
    });

    $(document).on("mouseout", ".hover-round-kill", function (e) {
        $(`.feed-round-kill[round=${$(this).attr("round")}][order=${$(this).attr("order")}]`).addClass("animate__fadeInDown").removeClass("animate__pulse").removeClass("justify-content-center").removeClass("bg-light-primary");
    });

});



/**
 * 
 * RENDER FUNCTIONS
 * 
 */
export function renderDuels(data){
    const frags = [...data.frags];
    let playerStats = {};

    frags.forEach((element) => {
        let killerSteamID = element.killer_steamid;
        let victimSteamID = element.victim_steamid;        

        if(playerStats[killerSteamID] === undefined) playerStats[killerSteamID] = { killsTo: {}, deathsBy: {} };
        if(playerStats[victimSteamID] === undefined) playerStats[victimSteamID] = { killsTo: {}, deathsBy: {} };

        playerStats[killerSteamID].killsTo[victimSteamID] = (playerStats[killerSteamID].killsTo[victimSteamID] || 0) + 1;
        playerStats[victimSteamID].deathsBy[killerSteamID] = (playerStats[victimSteamID].deathsBy[killerSteamID] || 0) + 1;

            
      });

    //console.log(playerStats);
    $(".duels-teamb").html(`<th class="text-center">VS</th>`);
    Object.keys(data.teamB).forEach(function(key, index) {
        if(data.teamB[key].matchstats === undefined) return;
        const player = data.teamB[key];
        //if(player.matchstats === undefined) return;        
        $(".duels-teamb").append(`<th><div class="w-100"><div class="d-flex flex-row flex-nowrap align-items-center justify-content-center align-self-center w-80px w-md-100px"><div class="symbol symbol-35px me-3"><img class="" src="${player.avatar ? player.avatar : 'assets/media/avatars/default.jpg'}"/></div> <a href="user/${player.communityid}" data-navigo class="text-gray-800 text-hover-white fs-7 lh-2 text-nowrap text-truncate">${player.nickname === undefined ? player.steamid.replace("BOT:", "") : sanitizeHTML(player.nickname)}</a></div></div></th>`);
    });
    
    Object.keys(data.teamA).forEach(function(key, index) {
        if(data.teamA[key].matchstats === undefined) return;
        const player = data.teamA[key];
        let html = `<tr><td class="fw-bolder text-gray-700 text-nowrap " style="background-color: #1b1b1b"><div class="d-flex flex-row flex-nowrap align-items-center w-80px w-md-100px"><div class="symbol symbol-35px me-3"><img class="" src="${player.avatar ? player.avatar : 'assets/media/avatars/default.jpg'}"/></div> <a href="user/${player.communityid}" data-navigo class="text-gray-800 text-hover-white fs-7 lh-2 text-nowrap text-truncate">${player.nickname === undefined ? player.steamid.replace("BOT:", "") : sanitizeHTML(player.nickname)}</a></div></td>`;
        for(let i = 0; i < Object.keys(data.teamB).length; i++)
        {
            let k = playerStats[key].killsTo[Object.keys(data.teamB)[i]] === undefined ? 0 : playerStats[key].killsTo[Object.keys(data.teamB)[i]];
            let d = playerStats[key].deathsBy[Object.keys(data.teamB)[i]] === undefined ? 0 : playerStats[key].deathsBy[Object.keys(data.teamB)[i]];
           html+=`<td class="duel-kill" killer="${Object.keys(data.teamB)[i]}" victim="${key}"><div class="d-flex justify-content-center align-items-center fs-2 gap-2"><span data-toggle="tooltip" title="${player.nickname} killed ${data.teamB[Object.keys(data.teamB)[i]].nickname} ${k} times" class="cursor-pointer fw-bold ${k > d ? "text-success" : (k < d ? "text-danger" : "text-warning")}">${k}</span> <span class="text-white">:</span> <span data-toggle="tooltip" title="${data.teamB[Object.keys(data.teamB)[i]].nickname} killed ${player.nickname} ${d} times" class="cursor-pointer fw-bold ${d > k ? "text-success" : (d < k ? "text-danger" : "text-warning")}">${d}</span></div></td>`;
        }
        html+=`</tr>`;
        $(".duels-teama").append(html);
    });
}

export function renderMatchDetails(data)
{
    console.log("Rendering Match Details");
    $(".match-details-map-header").css("background-image", `url('assets/media/maps/1080px/${data.map}.jpg')`);
    $(".match-details-date").html(`<span class="fs-7 text-gray-800 mb-1 fw-bold" data-i18n="example.datec" data-i18n-options='{"timestamp":"${parseInt(data.createdAt)+hostStampDif}"}'></span>`).localize();
    $(".match-details").find("#lobby-ongoing").attr("data-i18n","play."+states[data.state]).addClass("border-gray-700 text-gray-700 text-uppercase");
    $(".match-details").find(".lobby-team-A-name").text(data.teamA_name || "TEAM_A");
    $(".match-details").find(".lobby-team-B-name").text(data.teamB_name || "TEAM_B");

    let scoreA = 0;
    let scoreB = 0;

    if(data.scoreA == 0 && data.scoreB == 0 && data.state > 2) scoreA = data.scoreT;
    if(data.scoreA == 0 && data.scoreB == 0 && data.state > 2) scoreB = data.scoreCT;

    $(".match-details").find(".lobby-scorea").addClass(scoreA > scoreB ? 'text-primary' : 'text-gray-900').text(data.scoreA ? data.scoreA : data.scoreT);
    $(".match-details").find(".lobby-scoreb").addClass(scoreA < scoreB ? 'text-primary' : 'text-gray-900').text(data.scoreB ? data.scoreB : data.scoreCT);    

    $(".match-details").find(".winner-a").html(scoreA > scoreB ? `<i class="fs-2x fas fa-trophy-alt top-trophy-1 text-zyellow mb-2 me-3"></i>` : "");
    $(".match-details").find(".winner-b").html(scoreA < scoreB ? `<i class="fs-2x fas fa-trophy-alt top-trophy-1 text-zyellow mb-2 me-3"></i>` : "");

    let type = ``;
    if(data.type == "pug") type = `<span class="badge badge-sm badge-success flex-shrink-0 align-self-center text-gray-100">${data.type.toUpperCase()}</span>`;

    $(".match-details").find(".match-details-item-type").html(type == "" ? `<span class="badge badge-sm badge-success flex-shrink-0 align-self-center text-gray-100">${data.type.toUpperCase()}</span>` : type);
    $(".match-details").find(".match-details-item-server").html(`<img class="me-1" src="assets/media/flags/${data.server.flag}.gif"><span class="fw-bold text-gray-900 fs-7">${data.server.region}</span>`);
    $(".match-details").find(".match-details-item-map").text(data.map);
    $(".match-details").find(".match-details-item-duration").text(moment.unix(data.duration ? data.duration : 0).utc().format("HH:mm:ss"));


    $(".match-details").find(".match-details-roster-a").append(renderRosterTeam(data, "A"));
    $(".match-details").find(".match-details-roster-b").append(renderRosterTeam(data, "B"));

    if(data.zip == true)
    {
        $(".match-details").find(".match-details-hltv-demo").html(`<a href="https://cdn.pdxplay.org/demos/hltv/match-${data._id}.zip" class="badge badge-sm badge-primary external-handler text-gray-200 text-hover-white bg-hover-light-primary" data-i18n="example.download"></a>`).localize();

        let customHtml = `
            <div class="card card-flush bg-transparent">
                <div class="card-body">
                    <h5 class="card-title mb-3" data-i18n="example.dem_details">Demo details</h5>
                    <div class="d-flex flex-nowrap">
                        <div class="w-50 pe-1 text-end text-nowrap">
                            <p class="card-text mb-0"><b data-i18n="example.created">Created</b>:</p>
                            <p class="card-text mb-0"><b data-i18n="example.expires">Expires</b>:</p>
                            <p class="card-text mb-0"><b data-i18n="example.size">Size</b>:</p>
                        </div>
                        <div class="w-50 ps-1 text-start text-nowrap">
                            <p class="card-text mb-0">${moment.unix(parseInt(data.zip_details.created)+hostStampDif).locale(localStorage.getItem("i18nextLng")).fromNow()}</p>
                            <p class="card-text mb-0">${moment.unix(parseInt(data.zip_details.expires)+hostStampDif).locale(localStorage.getItem("i18nextLng")).fromNow()}</p>
                            <p class="card-text mb-0">${parseInt(parseInt(data.zip_details.size)/1000000)} MB</p>
                        </div>
                    </div>                    
                </div>
            </div>
        `;

        customHtml = $(customHtml);
        customHtml.localize();
        customHtml = customHtml.html();

        $(".match-details").find(".hltv-demo-container").attr('data-bs-toggle', 'tooltip').attr('data-bs-html', 'true').attr('title', `<div class="tooltip-custom">${customHtml}</div>`).tooltip();
    }
    else
    {
        let now = moment().unix();
        let ended = moment.unix(parseInt(data.updatedAt)+hostStampDif).add(1, 'minutes').unix();

        if(now - ended >= (60 * 60 * 24 * 30))
        {
            
            $(".match-details").find(".match-details-hltv-demo").html(`<span class="badge badge-sm badge-light" data-i18n="example.expired">Expired</span>`);
        }else if(now - ended >= 0){
            $(".match-details").find(".match-details-hltv-demo").html(`<span class="badge badge-sm badge-light" data-i18n="example.unavailable">Unavailable</span>`);
        }
        else
        {
            $(".match-details").find(".match-details-hltv-demo").html(`<span class="badge badge-sm badge-light"><span  data-i18n="example.processing">Processing...</span> <span class="spinner-border text-primary text-center" role="status" style="width: 10px; height: 10px;"><span class="visually-hidden">Loading...</span></span></span>`);
        }
    }

    $(".match-details").find(".match-details-hltv-demo").localize();
            
        

    calculateImpactRating(data, "A");
    calculateImpactRating(data, "B");

    //calculateBadges(data)
    renderBadges(data);
    renderScoreBoard(data, "A");
    renderScoreBoard(data, "B");

    renderRoundHistory(data);  
    renderDuels(data);


    $(".match-details").find("[data-toggle=tooltip]").tooltip();

    function renderRosterTeam(data, team)
    {
        if(team != "A" && team != "B") return ``;
        let html = [];

        Object.keys(data[`team${team}`]).forEach(function(key, index) {            
            if(data[`team${team}`][key].matchstats !== undefined) html.push(renderRosterPlayer(data[`team${team}`][key]));
        });
        return html;
    }

    function renderRosterPlayer(data)
    {
        let html = /* html */
        `<div class="d-flex flex-column align-items-center justify-content-center gap-2 w-75px ${data.matchstats.oldrating == 0 || data.matchstats.rounds == 0 ? 'opacity-50' : ''}">
            <div class="" data-toggle="tooltip" title="${data.country}">
                <img src="assets/media/flags/${data.countrycode ? data.countrycode.toLowerCase() : ''}.gif" alt="image" class="mw-100px h-auto">
            </div>
            <div class="symbol symbol-50px">
                <img src="${data.avatar ? data.avatar : "assets/media/avatars/default.jpg"}" alt="image">
            </div>
            <div class="w-75px text-truncate text-center overflow-hidden" data-toggle="tooltip" title="${data.nickname}">
                <span class="fw-bold text-gray-900 fs-7 pt-1 text-white dnick"></span>
            </div>
            <div class="" data-toggle="tooltip" title="${data.matchstats.oldrating}"><img src="assets/media/ranks/rank_${getEloLevel(data.matchstats.oldrating,data.matchstats.oldrd)}.png" alt="image" class="h-35px">
            </div>
        </div>`;

        html = $(html);
        html.find(".dnick").text(data.nickname ? data.nickname : data.steamid.replace("BOT:", ""));
        return html;
    }

    function calculateImpactRating(data, team)
    {
        if(team != "A" && team != "B") return ``;
        let totalRating = 0;
        Object.keys(data[`team${team}`]).forEach(function(key, index) {
            if(data[`team${team}`][key].matchstats === undefined) return;
            let who = data[`team${team}`][key].matchstats;
            
            //let impact =  ((who.kills * 1.2 + who.assists * 0.2 - who.deaths * 0.7 + who["v1"] * 0.3 + who["v2"] * 0.5 + who["v3"] * 0.7 + who["v4"] * 0.9 + who["v5"] * 1.1 + who.bombs_planted * 0.3 + who.bombs_defused * 0.3 + who.hs * 0.5 + (who.damage/(who.rounds ? who.rounds : 1)) * 0.1 + who.flash_assist * 0.1 + who.first_kill * 0.4 - who.first_death * 0.4) / who.rounds) * 2 * (who.rounds_win / who.rounds);

            let impact =  1 + 4 / (1 + Math.exp(-(((who.kills * 1.2 + who.assists * 0.2 - who.deaths * 0.7 + who["v1"] * 0.3 + who["v2"] * 0.5 + who["v3"] * 0.7 + who["v4"] * 0.9 + who["v5"] * 1.1 + who.bombs_planted * 0.3 + who.bombs_defused * 0.3 + who.hs * 0.5 + (who.damage/(who.rounds ? who.rounds : 1)) * 0.1 + who.flash_assist * 0.1 + who.first_kill * 0.4 - who.first_death * 0.4) / (who.rounds == 0 ? 1 : who.rounds)) - 2))) * Math.pow(0.2, (data.rounds.length - who.rounds) / data.rounds.length);

            totalRating += impact;
            data[`team${team}`][key].matchstats.impactRating = impact;
            data[`team${team}`][key].matchstats.adr = (who.damage/(who.rounds ? who.rounds : 1));
        });

        Object.keys(data[`team${team}`]).forEach(function(key, index) {  
            if(data[`team${team}`][key].matchstats === undefined) return; 
            data[`team${team}`][key].matchstats.impactRatingPercent = (data[`team${team}`][key].matchstats.impactRating / totalRating) * 100;
        });
    }

    function calculateBadges(data)
    {
        let ret = {};
        let pl = Object.assign({}, data.teamA, data.teamB);

        //console.log(pl);

        let topKiller;
        let topKills = -1;
        let topBomber;
        let topBombs = -1;
        let topDefuser;
        let topDefuses = -1;
        let topHeadshoter;
        let topHeadshots = -1;
        let topImpact;
        let topImpacts = -1;

        Object.keys(pl).forEach(function(key, index) {            
            const player = pl[key];
            if(player.matchstats === undefined) return;
            if(player.matchstats.kills > topKills){
                topKiller = key;
                topKills = player.matchstats.kills;
            }
            if(player.matchstats.bombs_planted > topBombs){
                topBomber = key;
                topBombs = player.matchstats.bombs_planted;
            }
            if(player.matchstats.bombs_defused > topDefuses){
                topDefuser = key;
                topDefuses = player.matchstats.bombs_defused;
            }
            if(player.matchstats.hs > topHeadshots){
                topHeadshoter = key;
                topHeadshots = player.matchstats.hs;
            }
            if(player.matchstats.impactRating > topImpacts){
                topImpact = key;
                topImpacts = player.matchstats.impactRating;
            }
        });

        ret.killer = topKiller;
        ret.bomber = topBomber;
        ret.defuser = topDefuser;
        ret.hs = topHeadshoter;
        ret.mvp = topImpact;

        return ret;
            
    }

    function renderBadges(data)
    {
        let pl = Object.assign({}, data.teamA, data.teamB);
        let badges = calculateBadges(data);
        //console.log(badges);
        Object.keys(badges).forEach(function(key, index) {
            const player = badges[key];
            //$(`.${key}`).html(renderBadge(player));

            $(`.badge-${key}-avatar`).attr("src", pl[player].avatar ? pl[player].avatar : "assets/media/avatars/default.jpg");
            $(`.badge-${key}-nick`).text(pl[player].nickname ? pl[player].nickname : pl[player].steamid.replace("BOT:", ""));
            $(`.badge-${key}-rank`).attr("src", `assets/media/ranks/rank_${getEloLevel(pl[player].matchstats.oldrating,pl[player].matchstats.oldrd)}.png`);
            $(`.badge-${key}-adr`).text(pl[player].matchstats.adr.toFixed(2));
            $(`.badge-${key}-kdr`).text((pl[player].matchstats.kills/(pl[player].matchstats.deaths == 0 ? 1 : pl[player].matchstats.deaths)).toFixed(2));
            $(`.badge-${key}-clutches`).text(pl[player].matchstats["v1"] + pl[player].matchstats["v2"] + pl[player].matchstats["v3"] + pl[player].matchstats["v4"] + pl[player].matchstats["v5"]);
            $(`.badge-${key}-hs`).text(pl[player].matchstats.hs);
            $(`.badge-${key}-fk`).text(pl[player].matchstats.first_kill);
            $(`.badge-${key}-assists`).text(pl[player].matchstats.assists);

        });        
    }

}

export function renderRoundHistory(data)
{
    if(data.rounds.length == 0) return;
    let html = [];
    let rounds = data.rounds;
    let frags = data.frags;
    let players = Object.assign({}, data.teamA, data.teamB);

    let imaxrounds = data.maxrounds ? data.maxrounds : 30;
    let imaxotrounds = data.maxotrounds ? data.maxotrounds : 6;

    let ichanged = false;
    
    rounds.forEach(function(round, i) {
        let indexesToRemove = [];
        round.frags = [];
        frags.forEach(function(frag, e) {
            if(frag.round !== undefined && frag.round == i)
            {
                frag.round++;
                round.frags.push(frag);
                indexesToRemove.push(e);
            }else if((round.createdAt+6) > frag.createdAt)
            {
                round.frags.push(frag);
                indexesToRemove.push(e);
            }
        });
        frags = removeItemsByIndexes(frags, indexesToRemove);
    });

    //console.log(rounds);
    let tmptscore = 0;
    let tmpctscore = 0;

    let tempAscore = 0;
    let tempBscore = 0;

    rounds.forEach(function(round, i) {

        let htmlplayersT = ``;
        let htmlplayersCT = ``;

        if(round.winner == 1)    tmptscore++;
        if(round.winner == 2) tmpctscore++;  
        
        let htmlfrags = ``;

        round.frags.forEach(function(frag, e) {
            let htmlplayer = `
                <div class="symbol symbol-35px ${frag.killer_team == 1 ? 'me' : 'ms'}-3 hover-round-kill cursor-pointer" round="${round.round}" order="${e}" data-toogle="tooltip" title="${sanitizeHTML(players[frag.killer_steamid].nickname)}">
                    <img class="" src="${players[frag.killer_steamid].avatar ? players[frag.killer_steamid].avatar : 'assets/media/avatars/default.jpg'}">
                </div>
            `;

            if(frag.killer_team == 1)
            {
                htmlplayersT += htmlplayer;
            }
            else
            {
                htmlplayersCT += htmlplayer;
            }
            
            frag.round = round.round;
            frag.order = e;
            htmlfrags += renderFrag(frag);
        });

        let badge = ``;
        if(round.event == ROUND_TARGET_BOMB) badge = `<i class="fas fa-bomb fs-2"></i>`;
        if(round.event == ROUND_BOMB_DEFUSED) badge = `<i class="fas fa-tools fs-2"></i>`;
        if(round.event == ROUND_CTS_WIN) badge = `<i class="fas fa-skull fs-2"></i>`;
        if(round.event == ROUND_TERRORISTS_WIN) badge = `<i class="fas fa-skull fs-2"></i>`;
        if(round.event == ROUND_TARGET_SAVED) badge = `<i class="fas fa-stopwatch fs-2"></i>`;

        //console.log(i, round.round);
        
        let htmlround =  `
            <div class="timeline-item pb-3">
                <div class="d-flex flex-row align-items-center align-self-center timeline-content m-0 justify-content-end me-3">
                    ${htmlplayersT}
                    <div class="d-flex justify-content-end fs-2x fw-bolder">
                        <span class="text-zred">${tmptscore}</span>
                    </div>
                </div>
            
                ${((i + 1) == rounds.length) ? `` : `<div class="timeline-line h-100 border-primary" style="left: 50%;right: 50%;top: 50%;"></div>`}
            
                <div class="d-flex timeline-icon ms-auto me-auto h-100 align-self-center flex-column align-items-center w-60px cursor-pointer" data-bs-toggle="collapse" data-bs-target="#round-${round.round}-details">
                    <span class="fs-8 fw-bolder text-gray-800 text-uppercase mb-2">Round ${round.round}</span>
                    <div class="symbol symbol-40px">
                        <span class="symbol-label">${badge}</span>
                    </div>
                </div>
                                        
                <div class="d-flex flex-row align-items-center align-self-center timeline-content m-0 justify-content-start ms-3">
                    <div class="d-flex justify-content-start fs-2x fw-bolder">
                        <span class="text-zblue">${tmpctscore}</span>
                    </div>
                    ${htmlplayersCT}
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <div id="round-${round.round}-details" class="card card-flush collapse">
                    <div class="card-body">
                        ${htmlfrags}
                    </div>
                </div>
            </div>
        `;

        htmlround = $(htmlround);
        html.push(htmlround);

        if(round.round == imaxrounds/2)
        {
            let change = `
                <div class="timeline-item pb-3">
                    <div class="timeline-line h-100 border-primary" style="left: 50%;right: 50%;top: 50%;"></div>
                    <div class="d-flex timeline-icon ms-auto me-auto h-100 align-self-center flex-column align-items-center w-60px">
                        <span class="fs-8 fw-bolder text-gray-800 text-uppercase mb-2">Half Time</span>
                        <div class="symbol symbol-40px">
                            <span class="symbol-label"><i class="fas fa-sync-alt fs-2"></i></span>
                        </div>
                    </div>
                </div>
            `;
            change = $(change);
            html.push(change);
            ichanged = true;
        }


    });

    $(".match-details-round-list").append(html);
    $(".match-details-round-list").find("[data-toogle=tooltip]").tooltip();

    function renderFrag(data)
    {
        if(data.assistant_steamid === undefined) data.assistant_steamid = "";
        if(data.flashassistant_steamid === undefined) data.flashassistant_steamid = "";
        if(data.noscope === undefined) data.noscope = 0;
        if(data.smoke === undefined) data.smoke = false;
        if(data.wallbang === undefined) data.wallbang = false;
        if(data.headshot === undefined) data.headshot = false;
        if(data.killer_flashed === undefined) data.killer_flashed = false;

        //console.log(data);


        let sk = `<div class="h-30px">
        <img class="h-100 mirror" src="assets/media/icons/smokekill.png">
        </div>`;
        let hs = `<div class="h-20px">
            <img class="h-100" src="assets/media/icons/hskill.png">
        </div>`;
        let wb = `<div class="h-30px">
            <img class="h-100" src="assets/media/icons/wbkill.png">
        </div>`;
        let blind = `<span class="h-25px">
            <img class="h-100" src="assets/media/icons/blindperson.png">
        </span>`;
        let dead = `<div class="h-25px">
            <img class="h-100" src="assets/media/icons/dead.png">
        </div>`;
        let ns = `<div class="h-30px">
            <img class="h-100" src="assets/media/icons/noscopekill.png">
        </div>`;
        let qs = `<div class="h-30px">
            <img class="h-100" src="assets/media/icons/quickscope.png">
        </div>`;
        let html = /* html */ `
            <div class="d-flex gap-2 align-items-center mb-2 min-h-35px rounded overflow-hidden animate__animated animate__fadeInDown feed-round-kill" round="${data.round}" order="${data.order}">
                <div class="d-flex flex-nowrap align-items-center gap-1 py-1 px-3 h-100 rounded" style="${data.killer_team == 1 ? 'background: rgb(253,29,29);' : 'background: rgb(111,30,255);'}">${data.killer_flashed == 1 ? blind : ''}<span class="text-white fs-7 fw-bold">${sanitizeHTML(players[data.killer_steamid].nickname)}</span>${data.assistant_steamid !== '' ? ` + <span class="text-white fs-7 fw-bold">${sanitizeHTML(players[data.assistant_steamid].nickname)}</span>`: ""}${data.flashassistant_steamid !== '' ? ` + <span class="h-30px"><img class="h-100" src="assets/media/icons/fbassist.png"/></span><span class="text-white fs-7">${sanitizeHTML(players[data.flashassistant_steamid].nickname)}</span>`: ""}</div>
                <div class="text-white d-flex align-items-center justify-content-center">
                    ${data.suicide == 1 ? dead : `<div class="h-20px">
                        <img class="h-100 mirror" src="assets/media/weapons/${data.weapon_id}.png">
                    </div>`}
                    ${data.noscope ? (data.noscope == 1 ? ns : qs): ''}
                    ${data.smoke == true ? sk: ''}
                    ${data.wallbang == true ?  wb: ''}
                    ${data.headshot == true ?  hs: ''}
                </div>
                <div class="d-flex flex-nowrap align-items-center text-white fs-7 fw-bold py-1 px-3 h-100 rounded" style="${data.victim_team == 1 ? 'background: rgb(253,29,29);' : 'background: rgb(111,30,255);'}">${sanitizeHTML(players[data.victim_steamid].nickname)}</div>
            </div>
        `;
        return html;

    }
}

function renderScoreBoard(data, team)
{
    if(team != "A" && team != "B") return ``;
    
    let dataset = [];

    Object.keys(data[`team${team}`]).forEach(function(key, index) {
        const player = data[`team${team}`][key];
        const stats = player.matchstats;
        if(stats === undefined) return;

        let datatmp = [];
        datatmp.push({steamid: player.steamid, avatar: player.avatar, communityid: player.communityid, nickname: player.nickname, country: player.country, city: player.city, flag: player.countrycode.toLowerCase()});
        datatmp.push({rating: stats.oldrating, rd: stats.oldrd, rank: getEloLevel(stats.oldrating, stats.oldrd), diff: (stats.rating - stats.oldrating).toFixed(0)});
        datatmp.push(stats.impactRating.toFixed(2));
        datatmp.push(stats.kills);
        datatmp.push(stats.assists);        
        datatmp.push(stats.deaths);
        datatmp.push({hs:stats.hs, hsp: ((stats.hs/(stats.kills ? stats.kills : 1))*100).toFixed(0)});
        datatmp.push(stats.tks);
        datatmp.push(stats.suicides);
        datatmp.push((stats.kills/(stats.deaths == 0 ? 1 : stats.deaths)).toFixed(2));
        datatmp.push((stats.damage/(stats.rounds == 0 ? 1 : stats.rounds)).toFixed(0));
        datatmp.push((stats.kills/(stats.rounds == 0 ? 1 : stats.rounds)).toFixed(2));
        datatmp.push((stats.assists/(stats.rounds == 0 ? 1 : stats.rounds)).toFixed(2));        
        datatmp.push(stats.first_kill);
        datatmp.push(stats.first_death);
        datatmp.push(stats.blind_kill);
        datatmp.push(stats.flash_assist);
        datatmp.push(stats.victim_flashed);
        datatmp.push(stats.smoke_kill);
        datatmp.push(stats.wb);
        datatmp.push(stats.qs);
        datatmp.push(stats.ns);
        datatmp.push(stats.rounds);
        datatmp.push(stats.rounds_win); 
        datatmp.push(stats.rounds_lose);
        datatmp.push(stats.bombs_planted);
        datatmp.push(stats.bombs_exploded);
        datatmp.push(stats.bombs_defused);
        datatmp.push(stats["v1"] + stats["v2"] + stats["v3"] + stats["v4"] + stats["v5"]);
        datatmp.push(stats["v1"]);
        datatmp.push(stats["v2"]);
        datatmp.push(stats["v3"]);
        datatmp.push(stats["v4"]);
        datatmp.push(stats["v5"]);
        datatmp.push(stats["k5"]);
        datatmp.push(stats["k4"]);
        datatmp.push(stats["k3"]);
        datatmp.push(stats["k2"]);
        datatmp.push(stats.damage);
        datatmp.push(stats.shots);
        datatmp.push(stats.hits);
        datatmp.push((stats.hits/(stats.shots == 0 ? 1 : stats.shots)*100).toFixed(2));
        datatmp.push(stats.hb_head);
        datatmp.push(stats.hb_chest);
        datatmp.push(stats.hb_stomach);
        datatmp.push(stats.hb_leftarm);
        datatmp.push(stats.hb_rightarm);
        datatmp.push(stats.hb_leftleg);
        datatmp.push(stats.hb_rightleg);

        dataset.push(datatmp);

    });        

    let scoreBoard = $(`#team${team}-scoreboard`).DataTable({
        //scrollY:        "300px",
        //scrollX:        true,
        //sScrollXInner: "100%",
        //scrollCollapse: true,    
        "bPaginate": false,
        "bFilter": false,
        "bInfo": false,
        language: {
            emptyTable: "",
            loadingRecords: "",
            zeroRecords: ""
        },
        fixedColumns:   {
            left: 1
        },
        data: dataset,
        "columnDefs": [ 
            {
                orderable: false,
                "target": 0,                 
                "render": function ( data, type, row, meta ) {
                    return `<div class="d-flex flex-row flex-nowrap align-items-center w-150px w-md-175px"><span class="d-flex align-self-center me-2" title="${data.city} ${data.country}" data-toggle="tooltip"><img class="" src="assets/media/flags/${data.flag}.gif"></span>  <div class="symbol symbol-35px me-3"><img class="" src="${data.avatar ? data.avatar : 'assets/media/avatars/default.jpg'}"/></div> <div class="d-flex justify-content-start flex-column text-nowrap text-truncate"><a href="user/${data.communityid}" data-navigo class="text-gray-800 text-hover-white fs-7 lh-2">${data.nickname === undefined ? data.steamid.replace("BOT:", "") : sanitizeHTML(data.nickname)}</a><a href="https://steamcommunity.com/profiles/${data.communityid}/" target="_blank" class="text-muted fw-semibold text-muted text-hover-info d-block fs-7 mw-125px">${data.steamid}</a></div></div>`;
                }
            },
            {
                orderable: true,
                "target": 1,
                "render": function ( data, type, row, meta ) {
                    return `<div class="d-flex align-items-center">
                    <div class="symbol symbol-35px me-5 rounded overflow-hidden">
                        <span class="symbol-label bg-transparent">
                            <img src="assets/media/ranks/rank_${data.rank}.png" class="h-100 align-self-center" alt="">
                        </span>
                    </div>
                    
                    <div class="d-flex justify-content-start align-items-center flex-row flex-nowrap">
                        <span class="text-dark fw-bold fs-7 me-2">${data.rating}</span> <span class="ps-2 badge fs-7 text-nowrap badge-light-${data.diff < 0 ? 'danger' : (data.diff == 0 ? 'gray-600' : 'success')}"><i class="fs-7 bi bi-arrow-${data.diff < 0 ? 'down' : (data.diff == 0 ? '' : 'up')} text-${data.diff < 0 ? 'danger' : (data.diff == 0 ? 'gray-600' : 'success')}"></i> ${data.diff < 0 ? data.diff*-1 : data.diff}</span>
                    </div>
                </div>`;
                }
            },
            {
                orderable: true,
                "target": 6,
                "render": function ( data, type, row, meta ) {
                    return `<span class="text-nowrap">${data.hs} / ${data.hsp}%</span>`;
                }
            },

        ],
        createdRow: function (row, data, index) {
            //console.log(row);
            //console.log(data);
            $(row).addClass(`player-row`).addClass('fs-7').attr("data-steamid", data[0].steamid);
            if(data[1].rating == 0 || data[22] == 0)  $(row).addClass(`opacity-50`);
        },
        order: [[2, 'desc']]
    });

    router.updatePageLinks();   

    if(team == "A"){
        if(scoreBoardA != null) scoreBoardA.destroy();
        scoreBoardA = scoreBoard;        
    }
    if(team == "B"){
        if(scoreBoardB != null) scoreBoardB.destroy();
        scoreBoardB = scoreBoard;        
    }
    
    $(`span.scoreboard-pill[tab="main"][team="${team}"]`).tab('show');


    $($.fn.dataTable.tables(true)).DataTable()
        .columns.adjust()
        .scroller.measure();
    
}


const getWinChance = (a, b) => {
    const constanteElo = 0.4;
    const chanceA = 100 / (1 + Math.pow(10, ((b - a) / constanteElo)));
    const chanceB = 100 / (1 + Math.pow(10, ((a - b) / constanteElo)));
    return {chanceA,chanceB};
};

const getEloLevel = (rate, rd) => {
    if(rd == 100) return 0;
    if(rate > 0 && rate < 801)
    {
        return 1;
    }
    if(rate > 800 && rate < 951)
    {
        return 2;
    }
    if(rate > 950 && rate < 1101)
    {
        return 3;
    }
    if(rate > 1100 && rate < 1251)
    {
        return 4;
    }
    if(rate > 1250 && rate < 1401)
    {
        return 5;
    }
    if(rate > 1400 && rate < 1551)
    {
        return 6;
    }
    if(rate > 1550 && rate < 1701)
    {
        return 7;
    }
    if(rate > 1700 && rate < 1851)
    {
        return 8;
    }
    if(rate > 1850 && rate < 2001)
    {
        return 9;
    }
    if(rate > 2000)
    {
        return 10;
    }
    return 0;
};

var clip = new ClipboardJS('.btn-copy');
clip.on('success', function (e) {
    
    e.clearSelection();
    if($(e.trigger).hasClass("copy-done")) return;
    let back = $(e.trigger).html();
    let backclass = $(e.trigger).attr("class");
    backclass = backclass.split(/\s+/);    
    backclass.map(cl => {$(e.trigger).removeClass(cl)});

    let fuckclass = "btn btn-sm btn-copy copy-done btn-icon btn-success";
    fuckclass = fuckclass.split(/\s+/);
    fuckclass.map(cl => {$(e.trigger).addClass(cl)});
    $(e.trigger).html(`<i class="bi bi-check fs-2x text-black"></i>`);

    var El = e.trigger;
    var popover = new bootstrap.Popover(El, {content: "Copied!", trigger: "manual"});
    popover.show();

    setTimeout(() => {
        fuckclass.map(cl => {$(e.trigger).removeClass(cl)});
        backclass.map(cl => {$(e.trigger).addClass(cl)});
        $(e.trigger).html(back);        
        popover.dispose();
    }, 2000);

  });


function sanitizeHTML(html) {
    const $temp = $("<div>");
    $temp.html(html);
    const sanitizedHTML = $temp.text();
    return sanitizedHTML;
}

const removeItemsByIndexes = (arr, indexes) => arr.filter((_, i) => !indexes.includes(i));



export default match;